module.exports = {"Company Update successfully":"Company Update successfully","Company Update failed":"Company Update failed"}